import { render, staticRenderFns } from "./PageFooterMedia.vue?vue&type=template&id=1017978e&"
import script from "./PageFooterMedia.vue?vue&type=script&lang=js&"
export * from "./PageFooterMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports